module.exports = __webpack_public_path__ + "static/images/containers/ClanLanding/images/icon_crystal.RU.2fb655b1.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanLanding/images/icon_crystal.RU.png
// module id = 2997
// module chunks = 11